import { useMutation } from "@apollo/client";
import type {
  UpdateProjectInput as UpdateProjectInputType,
  UpdateProjectPayload,
  ProjectPatch,
} from "@casey/db-types";
import { UPDATE_PROJECT, GET_ORGANIZATION_PROJECTS } from "../gql";

interface UpdateProjectInput {
  id: string;
  name?: string;
  description?: string;
  color?: string;
  visibility?: string;
}

interface UpdateProjectVariables {
  input: UpdateProjectInputType;
}

interface UpdateProjectResponse {
  updateProject: UpdateProjectPayload;
}

export function useUpdateProject() {
  const [updateProjectMutation, { data, loading, error }] = useMutation<
    UpdateProjectResponse,
    UpdateProjectVariables
  >(UPDATE_PROJECT, {
    refetchQueries: [{ query: GET_ORGANIZATION_PROJECTS }],
  });

  const updateProject = async (input: UpdateProjectInput) => {
    try {
      const patch: ProjectPatch = {};

      if (input.name !== undefined) patch.name = input.name;
      if (input.description !== undefined)
        patch.description = input.description;
      if (input.color !== undefined) patch.color = input.color;
      if (input.visibility !== undefined) patch.visibility = input.visibility;

      const result = await updateProjectMutation({
        variables: {
          input: {
            id: input.id,
            patch,
          },
        },
      });

      return result.data?.updateProject?.project;
    } catch (err) {
      console.error("Error updating project:", err);
      throw err;
    }
  };

  return {
    updateProject,
    data: data?.updateProject?.project,
    loading,
    error,
  };
}

export type { UpdateProjectInput };
